import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class BndesService {
    constructor(private dataService: DataService) { }

    public get(page: number, order: string, orderT: string, filter: any) {

        let params = new HttpParams()
            .set('filter.page', page.toString())
            .set('filter.entity.title', filter.title)
            .set('filter.entity.startDate', filter.startDate)
            .set('filter.entity.endDate', filter.endDate)
            .set('filter.orderByField', order)
            .set('filter.orderBy', orderT);

        return this.dataService.get<Result<any>>("bndes", params);
    }

    public getAll() {

        let params = new HttpParams()
            .set('filter.pageSize', '999');

        return this.dataService.get<Result<any>>("bndes", params);
    }

    public delete(cod: number) {
        return this.dataService.delete<Result>('bndes/' + cod.toString());
    }

    public save(bndes: any) {
        return this.dataService.post<Result>('bndes', bndes);
    }
}
